import { paginationTableProps, tableStandardProps } from "@/utils/componentUtils";
import { URLQuery } from "@/utils/queryUtils";
import { numberOrZero } from "@/utils/utils";
import { Card, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router";
import { useFilterCommissionsSettingsLevels } from "../../../../../../common/api/queries";
import ActionTextIcon from "../../../../../../common/components/icons/ActionTextIcon";
import Ellipsis from "../../../../../../common/components/views/Ellipsis";
import { TableSizes } from "../../../../../../common/constants";
import { COMMISSIONS_LEVEL_ROUTE_PATHS } from "../../../paths";
import { CommissionsSettingsLevelBase, CommissionsSettingsLevelFilterPageRequest } from "../../../types";
import CommissionsLevelTypeTag from "../../CommissionsLevelTypeTag";

interface Props {
  searchParams: CommissionsSettingsLevelFilterPageRequest;
}

const CommissionsLevelTableView = ({ searchParams }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isFetching } = useFilterCommissionsSettingsLevels(searchParams);

  const columns: ColumnsType<CommissionsSettingsLevelBase> = [
    {
      key: "type",
      title: t("common.type"),
      width: 110,
      render: (_, record) => <CommissionsLevelTypeTag type={record.type} />,
    },
    {
      key: "category",
      title: t("commissions.level.attrs.category"),
      width: 150,
      ellipsis: { showTitle: false },
      render: (_, record) => <Ellipsis>{record.category}</Ellipsis>,
    },
    {
      key: "code",
      title: t("commissions.level.attrs.code"),
      width: 120,
      ellipsis: { showTitle: false },
      render: (_, record) => <Ellipsis>{record.code}</Ellipsis>,
    },
    {
      key: "name",
      title: t("commissions.level.attrs.name"),
      ellipsis: { showTitle: false },
      render: (_, record) => <Ellipsis>{record.name}</Ellipsis>,
    },
    {
      key: "actions",
      align: "right",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <ActionTextIcon
          path={generatePath(COMMISSIONS_LEVEL_ROUTE_PATHS.detail.to, { id: record.id })}
          icon="eye"
          color="blue"
          text={t("common.show")}
        />
      ),
    },
  ];

  return (
    <Card className="card-box">
      <Table<CommissionsSettingsLevelBase>
        {...tableStandardProps()}
        columns={columns}
        loading={isFetching}
        scroll={{ x: TableSizes.SMALL }}
        dataSource={data?.pageData}
        pagination={{
          ...paginationTableProps,
          current: numberOrZero(data?.pageIndex) + 1,
          pageSize: data?.pageSize,
          total: data?.totalElementsCount,
          onChange: (pageIndex) => navigate({ search: URLQuery.getTableChangePageIndex(pageIndex) }, { replace: true }),
        }}
      />
    </Card>
  );
};

export default CommissionsLevelTableView;
